// config/commonConfig.js
const commonConfig = {
  classicHeader: true,
  darkTheme: false,
};

export { commonConfig };
